import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots } from "vue";
var _hoisted_1 = { class: "depart-return-picker__field" };
var _hoisted_2 = {
    key: 0,
    class: "depart-return-picker__separator"
};
var _hoisted_3 = {
    key: 1,
    class: "depart-return-picker__field"
};
var _hoisted_4 = { class: "base-model__header" };
var _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-arrowleft icon--xs",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_6 = [
    _hoisted_5
];
var _hoisted_7 = {
    key: 0,
    class: "depart-return-picker__header-controls"
};
var _hoisted_8 = {
    key: 0,
    class: "checkbox-field"
};
var _hoisted_9 = ["checked"];
var _hoisted_10 = { for: "oneway" };
var _hoisted_11 = { class: "checkbox-label" };
var _hoisted_12 = { key: 1 };
var _hoisted_13 = ["disabled"];
var _hoisted_14 = {
    key: 0,
    class: "depart-return-picker__header-controls"
};
var _hoisted_15 = ["disabled"];
var _hoisted_16 = {
    key: 0,
    class: "checkbox-field"
};
var _hoisted_17 = ["checked"];
var _hoisted_18 = { for: "oneway" };
var _hoisted_19 = { class: "checkbox-label" };
var _hoisted_20 = { class: "base-model__footer" };
var _hoisted_21 = {
    key: 0,
    class: "depart-return-picker__trip-length"
};
var _hoisted_22 = { class: "depart-return-picker__trip-length__text" };
var _hoisted_23 = { class: "depart-return-picker__trip-length__counter" };
var _hoisted_24 = { class: "depart-return-picker__trip-length__text" };
import { computed, ref, watch, defineAsyncComponent, inject, defineComponent } from 'vue';
import { useElementSize } from '@vueuse/core';
import InputField from '../InputField/InputField.vue';
import CounterControl from '../CounterControl/CounterControl.vue';
import DropdownContainer from '../DropdownContainer/DropdownContainer.vue';
import useMatchMedia from '../../hooks/useMatchMedia';
import useCalendarApiPriceProvider from '../../hooks/useCalendarApiPriceProvider';
import { formatDateShort } from '../../lib/dateUtils';
var defaultPricesDisclaimerTemplateString = 'Showing prices in {{ currency }} for';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DepartReturnPicker',
    props: {
        disabledDates: { default: function (props) { var _a; return (_a = props.disabledDates) !== null && _a !== void 0 ? _a : []; } },
        minDate: { default: function (props) { var _a; return (_a = props.minDate) !== null && _a !== void 0 ? _a : new Date(); } },
        maxDate: { default: function (props) { return props.maxDate; } },
        name: {},
        oneWay: { type: Boolean },
        showReset: { type: Boolean, default: true },
        showOneWay: { type: Boolean, default: true },
        tripLength: {},
        defaultTripLength: {},
        departValue: {},
        returnValue: {},
        departFieldName: { default: 'departDate' },
        returnFieldName: { default: 'returnDate' },
        apiPrices: {},
        showPrices: { type: Boolean, default: false }
    },
    emits: ["update:departValue", "update:returnValue", "update:displayMonth", "update:tripLength", "update:oneWay", "update:departValueRaw", "update:returnValueRaw"],
    setup: function (__props, _a) {
        var emits = _a.emit;
        var props = __props;
        var CalendarControl = defineAsyncComponent(function () { return import(
        /* webpackChunkName: "calendarControl" */
        '../CalendarControl/CalendarControl.vue'); });
        var isMobile = useMatchMedia('(max-width: 990px)');
        var departValueRef = ref(props.departValue ? props.departValue : undefined);
        var returnValueRef = ref(props.returnValue ? props.returnValue : undefined);
        var oneWayRef = ref(props.oneWay ? props.oneWay : false);
        var calendarRef = ref();
        var apiPricesRef = ref(props.apiPrices);
        var calendarContainerRef = ref(null);
        var showCalendar = ref(false);
        var departReturnPickerRef = ref();
        var cmsProps = inject('cms-props');
        var departLabel = computed(function () {
            var _a;
            if ((_a = cmsProps === null || cmsProps === void 0 ? void 0 : cmsProps.value) === null || _a === void 0 ? void 0 : _a.departDateLabel.value)
                return cmsProps === null || cmsProps === void 0 ? void 0 : cmsProps.value.departDateLabel.value;
            var val = departValueRef.value ? 'Depart' : 'Depart date';
            return val;
        });
        var returnLabel = computed(function () {
            var _a;
            if ((_a = cmsProps === null || cmsProps === void 0 ? void 0 : cmsProps.value) === null || _a === void 0 ? void 0 : _a.departDateLabel.value)
                return cmsProps === null || cmsProps === void 0 ? void 0 : cmsProps.value.returnDateLabel.value;
            var val = returnValueRef.value ? 'Return' : 'Return date';
            return val;
        });
        var PricesDisclaimer = computed(function () {
            var _a, _b, _c;
            return defineComponent({
                props: {
                    currency: {
                        type: String,
                        required: true,
                    },
                },
                template: (_c = (_b = (_a = cmsProps === null || cmsProps === void 0 ? void 0 : cmsProps.value) === null || _a === void 0 ? void 0 : _a.pricesDisclaimerTextStart) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : defaultPricesDisclaimerTemplateString,
            });
        });
        var calendarContainerWidth = useElementSize(calendarContainerRef).width;
        var createSafeDate = function (dateString, fallback) {
            return dateString ? new Date(dateString) : fallback;
        };
        var calendarDefaultValue = computed(function () {
            var departDate = createSafeDate(departValueRef.value, props.oneWay && props.minDate ? new Date(props.minDate) : undefined);
            var returnDate = createSafeDate(returnValueRef.value, undefined);
            return [departDate, returnDate];
        });
        if (props.showPrices) {
            useCalendarApiPriceProvider(apiPricesRef, departValueRef, returnValueRef, oneWayRef);
        }
        watch(function () { return props.apiPrices; }, function (newApiPrices) {
            apiPricesRef.value = newApiPrices;
        }, { immediate: true, deep: true });
        var currency = computed(function () {
            var _a, _b, _c, _d;
            if (apiPricesRef.value) {
                // @ts-ignore
                var map = (_c = (_b = (_a = apiPricesRef.value.dictionaries) === null || _a === void 0 ? void 0 : _a.dictionaries) === null || _b === void 0 ? void 0 : _b.currency) !== null && _c !== void 0 ? _c : {};
                return (_d = Object.keys(map)[0]) !== null && _d !== void 0 ? _d : '';
            }
            return '';
        });
        var onValueChange = function (newValue) {
            var _a, _b, _c, _d;
            emits('update:departValueRaw', (_a = newValue[0]) !== null && _a !== void 0 ? _a : '');
            emits('update:returnValueRaw', (_b = newValue[1]) !== null && _b !== void 0 ? _b : '');
            departValueRef.value = newValue[0] ? formatDateShort(newValue[0]) : undefined;
            returnValueRef.value = newValue[1] ? formatDateShort(newValue[1]) : undefined;
            emits('update:departValue', (_c = departValueRef.value) !== null && _c !== void 0 ? _c : '');
            emits('update:returnValue', (_d = returnValueRef.value) !== null && _d !== void 0 ? _d : '');
            if (oneWayRef.value && departValueRef.value) {
                onClose();
            }
        };
        var onReset = function () {
            onValueChange([undefined, undefined]);
            calendarRef.value.reset();
        };
        var onClose = function () {
            var _a;
            (_a = departReturnPickerRef.value) === null || _a === void 0 ? void 0 : _a.focus();
            showCalendar.value = false;
        };
        var onUpdateOneWay = function (event) {
            var target = event.target;
            oneWayRef.value = target.checked;
            emits('update:oneWay', target.checked);
        };
        watch(function () { return props.departValue; }, function (newValue) {
            if (newValue !== departValueRef.value) {
                departValueRef.value = newValue;
            }
        });
        watch(function () { return props.returnValue; }, function (newValue) {
            if (newValue !== returnValueRef.value) {
                returnValueRef.value = newValue;
            }
        });
        watch(function () { return props.oneWay; }, function (newValue) {
            if (typeof newValue !== 'undefined' && newValue !== oneWayRef.value) {
                oneWayRef.value = newValue;
            }
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
                    'depart-return-picker',
                    {
                        'depart-return-picker--full-screen': _unref(isMobile),
                        'depart-return-picker--calendar-shown': showCalendar.value,
                        'depart-return-picker--values-selected': departValueRef.value && returnValueRef.value,
                    },
                ])
            }, [
                _createElementVNode("div", {
                    ref_key: "departReturnPickerRef",
                    ref: departReturnPickerRef,
                    tabindex: "0",
                    class: "depart-return-picker__fields",
                    style: _normalizeStyle({ 'pointer-events': showCalendar.value ? 'none' : 'initial' }),
                    onClick: _cache[2] || (_cache[2] = function ($event) { return (showCalendar.value = true); }),
                    onFocus: _cache[3] || (_cache[3] = function ($event) { return (showCalendar.value = true); })
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(InputField, {
                            modelValue: departValueRef.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((departValueRef).value = $event); }),
                            "icon-left": "icon icon-calendar",
                            label: departLabel.value,
                            readonly: "true",
                            "force-focus": showCalendar.value && !departValueRef.value ? 'true' : 'false',
                            style: { "pointer-events": "none" },
                            name: _ctx.departFieldName
                        }, null, 8 /* PROPS */, ["modelValue", "label", "force-focus", "name"])
                    ]),
                    (!oneWayRef.value &&
                        ((showCalendar.value && departValueRef.value && returnValueRef.value) || !showCalendar.value))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                        : _createCommentVNode("v-if", true),
                    (!oneWayRef.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(InputField, {
                                modelValue: returnValueRef.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((returnValueRef).value = $event); }),
                                label: returnLabel.value,
                                readonly: "true",
                                "force-focus": showCalendar.value && departValueRef.value && !returnValueRef.value ? 'true' : 'false',
                                style: { "pointer-events": "none" },
                                name: _ctx.returnFieldName,
                                "additional-classes": oneWayRef.value === false && departValueRef.value && !returnValueRef.value && !showCalendar.value ? 'hasError' : ''
                            }, null, 8 /* PROPS */, ["modelValue", "label", "force-focus", "name", "additional-classes"])
                        ]))
                        : _createCommentVNode("v-if", true)
                ], 36 /* STYLE, HYDRATE_EVENTS */),
                _createVNode(DropdownContainer, {
                    "full-screen": _unref(isMobile),
                    open: showCalendar.value,
                    "onClick:outside": _cache[10] || (_cache[10] = function ($event) { return (showCalendar.value = false); })
                }, _createSlots({
                    footer: _withCtx(function () {
                        var _a, _b, _c, _d, _e, _f, _g;
                        return [
                            _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", null, [
                                    (!_ctx.oneWay && !!_ctx.apiPrices && _ctx.showPrices)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                                            _createElementVNode("span", _hoisted_22, [
                                                _createVNode(_unref(PricesDisclaimer), { currency: currency.value }, null, 8 /* PROPS */, ["currency"])
                                            ]),
                                            _createElementVNode("span", _hoisted_23, [
                                                _createVNode(CounterControl, {
                                                    "model-value": _ctx.tripLength,
                                                    defaultValue: (_c = (_b = (_a = _unref(cmsProps)) === null || _a === void 0 ? void 0 : _a.defaultTripLength) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : 15,
                                                    name: "tripLength",
                                                    size: "small",
                                                    max: 15,
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) { return (_ctx.$emit('update:tripLength', $event)); })
                                                }, null, 8 /* PROPS */, ["model-value", "defaultValue"])
                                            ]),
                                            _createElementVNode("span", _hoisted_24, _toDisplayString((_e = (_d = _unref(cmsProps)) === null || _d === void 0 ? void 0 : _d.pricesDisclaimerTextEnd.value) !== null && _e !== void 0 ? _e : 'day trip'), 1 /* TEXT */)
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _createElementVNode("button", {
                                    class: "button button--primary",
                                    onClick: onClose
                                }, _toDisplayString((_g = (_f = _unref(cmsProps)) === null || _f === void 0 ? void 0 : _f.datePickerDoneLabel.value) !== null && _g !== void 0 ? _g : 'Done'), 1 /* TEXT */)
                            ])
                        ];
                    }),
                    default: _withCtx(function () {
                        var _a, _b, _c, _d;
                        return [
                            (!_unref(isMobile))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("button", {
                                        class: "button--sm button--text",
                                        role: "button",
                                        disabled: !departValueRef.value && !returnValueRef.value,
                                        onClick: onReset
                                    }, _toDisplayString((_b = (_a = _unref(cmsProps)) === null || _a === void 0 ? void 0 : _a.resetButtonLabel.value) !== null && _b !== void 0 ? _b : 'Reset'), 9 /* TEXT, PROPS */, _hoisted_15),
                                    (_ctx.showOneWay)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            _createElementVNode("span", null, [
                                                _createElementVNode("input", {
                                                    checked: oneWayRef.value,
                                                    onInput: onUpdateOneWay,
                                                    type: "checkbox",
                                                    name: "oneway"
                                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_17)
                                            ]),
                                            _createElementVNode("span", null, [
                                                _createElementVNode("label", _hoisted_18, [
                                                    _createElementVNode("p", _hoisted_19, _toDisplayString((_d = (_c = _unref(cmsProps)) === null || _c === void 0 ? void 0 : _c.oneWayCheckboxLabel.value) !== null && _d !== void 0 ? _d : 'One-way'), 1 /* TEXT */)
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("div", {
                                ref_key: "calendarContainerRef",
                                ref: calendarContainerRef
                            }, [
                                _createVNode(_unref(CalendarControl), {
                                    ref_key: "calendarRef",
                                    ref: calendarRef,
                                    disabledDates: _ctx.disabledDates,
                                    range: !_ctx.oneWay,
                                    minDate: _ctx.minDate,
                                    maxDate: _ctx.maxDate,
                                    defaultValue: calendarDefaultValue.value,
                                    mode: _unref(isMobile)
                                        ? 'stacked'
                                        : _unref(calendarContainerWidth) < 700
                                            ? 'single'
                                            : 'double',
                                    "onUpdate:date": onValueChange,
                                    "onUpdate:displayMonth": _cache[8] || (_cache[8] = function (month) { return _ctx.$emit('update:displayMonth', month); })
                                }, null, 8 /* PROPS */, ["disabledDates", "range", "minDate", "maxDate", "defaultValue", "mode"])
                            ], 512 /* NEED_PATCH */)
                        ];
                    }),
                    _: 2 /* DYNAMIC */
                }, [
                    (_unref(isMobile))
                        ? {
                            name: "header",
                            fn: _withCtx(function () {
                                var _a, _b, _c, _d;
                                return [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("button", {
                                            class: "button--text button--icon base-model__header-close m-r--8",
                                            "aria-label": "Dismiss modal",
                                            role: "button",
                                            onClick: _cache[4] || (_cache[4] = function ($event) { return (showCalendar.value = false); })
                                        }, _hoisted_6),
                                        (_unref(isMobile))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                (_ctx.showOneWay)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                        _createElementVNode("span", null, [
                                                            _createElementVNode("input", {
                                                                type: "checkbox",
                                                                name: "oneway",
                                                                checked: oneWayRef.value,
                                                                onInput: onUpdateOneWay
                                                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_9)
                                                        ]),
                                                        _createElementVNode("span", null, [
                                                            _createElementVNode("label", _hoisted_10, [
                                                                _createElementVNode("p", _hoisted_11, _toDisplayString((_b = (_a = _unref(cmsProps)) === null || _a === void 0 ? void 0 : _a.oneWayCheckboxLabel.value) !== null && _b !== void 0 ? _b : 'One-way'), 1 /* TEXT */)
                                                            ])
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("v-if", true),
                                                (!_ctx.showOneWay)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                                                    : _createCommentVNode("v-if", true),
                                                _createElementVNode("button", {
                                                    class: "button--sm button--text",
                                                    role: "button",
                                                    disabled: !departValueRef.value && !returnValueRef.value,
                                                    onClick: onReset
                                                }, _toDisplayString((_d = (_c = _unref(cmsProps)) === null || _c === void 0 ? void 0 : _c.resetButtonLabel.value) !== null && _d !== void 0 ? _d : 'Reset'), 9 /* TEXT, PROPS */, _hoisted_13)
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    (!oneWayRef.value)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "depart-return-picker__fields",
                                            style: _normalizeStyle({ 'pointer-events': showCalendar.value ? 'none' : 'initial' }),
                                            onClick: _cache[7] || (_cache[7] = function ($event) { return (showCalendar.value = true); })
                                        }, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass([
                                                    'depart-return-picker__field',
                                                    {
                                                        'depart-return-picker__field--active': (showCalendar.value && !departValueRef.value) ||
                                                            (showCalendar.value && oneWayRef.value),
                                                    },
                                                ])
                                            }, [
                                                _createVNode(InputField, {
                                                    modelValue: departValueRef.value,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((departValueRef).value = $event); }),
                                                    "icon-left": "icon icon-calendar",
                                                    label: departLabel.value,
                                                    readonly: "true",
                                                    "force-focus": showCalendar.value && !departValueRef.value ? 'true' : 'false',
                                                    style: { "pointer-events": "none" },
                                                    name: _ctx.departFieldName
                                                }, null, 8 /* PROPS */, ["modelValue", "label", "force-focus", "name"])
                                            ], 2 /* CLASS */),
                                            _createElementVNode("div", {
                                                class: _normalizeClass([
                                                    'depart-return-picker__field',
                                                    {
                                                        'depart-return-picker__field--active': showCalendar.value &&
                                                            departValueRef.value &&
                                                            !returnValueRef.value &&
                                                            !oneWayRef.value,
                                                    },
                                                ])
                                            }, [
                                                _createVNode(InputField, {
                                                    modelValue: returnValueRef.value,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((returnValueRef).value = $event); }),
                                                    "icon-left": "icon icon-calendar",
                                                    label: returnLabel.value,
                                                    readonly: "true",
                                                    "force-focus": showCalendar.value && departValueRef.value && !returnValueRef.value
                                                        ? 'true'
                                                        : 'false',
                                                    style: { "pointer-events": "none" },
                                                    name: _ctx.returnFieldName
                                                }, null, 8 /* PROPS */, ["modelValue", "label", "force-focus", "name"])
                                            ], 2 /* CLASS */)
                                        ], 4 /* STYLE */))
                                        : _createCommentVNode("v-if", true)
                                ];
                            }),
                            key: "0"
                        }
                        : undefined
                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["full-screen", "open"])
            ], 2 /* CLASS */));
        };
    }
});
